import { Select, Stack, Tabs } from '@mantine/core'
import { IconUsers } from '@tabler/icons-react'
import { observer } from 'mobx-react-lite'
import { parse } from 'qs'
import { useEffect, useState } from 'react'
import { useSearch } from 'wouter'

import { Screen } from '@/components/Screen'
import { type TabKey, TabKeys } from '@/constants/TabKeys'
import useCheckMobileScreen from '@/hooks/useCheckMobileScreen'

import { AppUsersPanel } from './SetupScreen/AppUsersPanel'
import { CustomerRepsPanel } from './SetupScreen/CustomerRepsPanel'
import { SmeManagementPanel } from './SetupScreen/SmeManagementPanel'

export const PeopleScreen = observer(function PeopleScreen() {
  const [activeTab, setActiveTab] = useState<TabKey>(TabKeys.appUsers)
  const searchParamsString = useSearch()
  const searchParams: { tab?: string } = parse(searchParamsString)
  const isMobile = useCheckMobileScreen()

  // Dropdown options for mobile view
  const tabOptions = [
    { value: TabKeys.appUsers, label: 'End Users' },
    { value: TabKeys.smeManagement, label: 'Experts' },
    { value: TabKeys.customerReps, label: 'Program Managers' },
  ]

  // Set active tab from URL parameter if provided
  useEffect(() => {
    if (searchParams.tab && Object.values(TabKeys).includes(searchParams.tab as TabKey)) {
      setActiveTab(searchParams.tab as TabKey)
    }
  }, [searchParams.tab])

  const handleTabChange = (value: string | null) => {
    if (value && Object.values(TabKeys).includes(value as TabKey)) {
      setActiveTab(value as TabKey)
    }
  }

  return (
    <Screen title="People" icon={IconUsers}>
      <Stack gap="md">
        {isMobile ? (
          <>
            <Select
              value={activeTab}
              onChange={handleTabChange}
              data={tabOptions}
              size="lg"
              fw={500}
              placeholder="Select a people section"
            />
          </>
        ) : (
          <Tabs value={activeTab} onChange={handleTabChange}>
            <Tabs.List>
              <Tabs.Tab value={TabKeys.appUsers} fw={500} fz="lg">
                End Users
              </Tabs.Tab>
              <Tabs.Tab value={TabKeys.smeManagement} fw={500} fz="lg">
                Experts
              </Tabs.Tab>
              <Tabs.Tab value={TabKeys.customerReps} fw={500} fz="lg">
                Program Managers
              </Tabs.Tab>
            </Tabs.List>
          </Tabs>
        )}

        {/* Tab panels - shown for both mobile and desktop */}
        <div>
          {activeTab === TabKeys.smeManagement && <SmeManagementPanel showTutorialText={true} />}

          {activeTab === TabKeys.appUsers && <AppUsersPanel showTutorialText={true} />}

          {activeTab === TabKeys.customerReps && <CustomerRepsPanel showTutorialText={true} />}
        </div>
      </Stack>
    </Screen>
  )
})
